import React, { useContext, useEffect } from 'react';
import styles from './UserReports.module.scss';
import { PropertyType, useStore } from '../../../../../common';
import { Checkbox, Skeleton } from 'esa-ui-library';
import { AuthContext } from '../../../../../logic';

const UserReports = (): JSX.Element => {
	const [state, dispatch] = useStore(false);
	const { reports, mailReportModal, selectedReports, savingData } = state;
	const { token } = useContext(AuthContext);
	const skeletonItems = Array.from({ length: 6 }, (_, index) => (
		<Skeleton key={index} variant='rounded' animation='wave' width='100%' height={24} />
	));

	const selectReportHandler = (selected: PropertyType, checked: boolean): void => {
		const mapSelected = checked
			? [...selectedReports, selected.value]
			: selectedReports.filter((r: number) => r !== selected.value);
		dispatch('REPORTS_SELECT', mapSelected);
	};

	useEffect(() => {
		dispatch('SAVING', true);
		dispatch('REPORTS_USER', { token, userId: mailReportModal });
	}, []);

	return (
		<section className={styles.UserReports}>
			{savingData
				? skeletonItems
				: reports.map((item: PropertyType) => (
						<div key={item.value} className={styles.ReportItem}>
							<Checkbox
								label={item.label}
								checked={selectedReports.includes(item.value)}
								className={styles.Option}
								onChange={(e) => {
									selectReportHandler(item, e);
								}}
							/>
						</div>
				  ))}
		</section>
	);
};

export { UserReports };
